export const lensAddresses = {
  accountLens: "0x960D481229f70c3c1CBCD3fA2d223f55Db9f36Ee",
  eulerEarnVaultLens: "0x618b0954b83Fa24A18FB650D80FC3bAbD162c4A2",
  irmLens: "0x615e1dAb9cF1Ad2b065B0c85720258c8d6236004",
  oracleLens: "0x0dE96d33afF54F3e8750567F6038A05c6D3aAa96",
  utilsLens: "0x3043f84052981c098c74A1d02bbf125D0cB20e50",
  vaultLens: "0x15d1Cc54fB3f7C0498fc991a23d8Dc00DF3c32A0",
} as const
